export const hubFields = Object.freeze([
  'CAM_ChiaveNaturale',
  'CAM_Cercabile',
  'CAM_Versioned',
  'CAM_Cifrato',
  'CAM_NomeUi',
  'CAM_ErroreValidazione',
]);

